export default __webpack_public_path__ + "static/media/hht2_ep17_timeline_q01_b.1c8b9d14.png";